import { FilamentForm } from './FilamentForm'

export function AddFilament() {
  return <FilamentForm />
}
